import React from 'react';
import Icon from 'components/blocks/Icon/Icon';
import './AppointmentCardNew.scss';

interface IAppointmentCardNew {
  appt: any;
  isPast?: boolean;
  onClick: () => void;
}

const MONTH_ABBR = ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];

const AppointmentCardNew: React.FC<IAppointmentCardNew> = ({ appt, isPast, onClick }) => {
  const stateKey =
    appt.realizada ? 'success' :
    appt.reprogramada ? 'warn' :
    'info';

  const stateLabel =
    appt.realizada ? 'Realizada' :
    appt.reprogramada ? 'Reprogramada' :
    (appt.estado || 'Confirmada');

  const place = appt.centro?.descripcion || appt.centro?.nombre || '';

  const parts = (appt.formated_start || '').split('/');
  const day = parts[0] || '--';
  const mon = parts[1] ? (MONTH_ABBR[parseInt(parts[1], 10) - 1] ?? '--') : '--';

  return (
    <article
      className={`appt${isPast ? ' appt--past' : ''}`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); }
      }}
    >
      <div className="appt__date">
        <div className="day">{day}</div>
        <div className="mon">{mon}</div>
      </div>
      <div className="appt__body">
        <div className="spec">{appt.especialidad ?? appt.spec}</div>
        <div className="appt__meta">
          <span className="appt__meta-item">
            <Icon name="calendar" size={16} /> {appt.formated_hour ?? appt.time}
          </span>
          {place && (
            <span className="appt__meta-item">
              <Icon name="pin" size={16} /> {place}
            </span>
          )}
        </div>
      </div>
      <div className="appt__aside">
        <span className={`pill pill--dot pill--${stateKey}`}>{stateLabel}</span>
        <button
          className="btn btn--secondary btn--sm"
          onClick={(e) => { e.stopPropagation(); onClick(); }}
        >
          Detalles
        </button>
      </div>
    </article>
  );
};

export default AppointmentCardNew;
